import { render, staticRenderFns } from "./CourseSyllabusListing.vue?vue&type=template&id=932b1e02&"
import script from "./CourseSyllabusListing.vue?vue&type=script&lang=js&"
export * from "./CourseSyllabusListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports